import React from 'react';
import { useNavigate } from 'react-router-dom';

import CasButton, { ICasButton } from '../CasButton/CasButton';

interface Props {
  to: string;
  children: React.ReactNode;
  variant?: ICasButton['variant'];
}

export default function CasNavLink({ to, children, variant = 'text' }: Props) {
  const navigate = useNavigate();

  return (
    <CasButton onClick={() => navigate(to)} variant={variant}>
      {children}
    </CasButton>
  );
}
